import React from 'react';
import { Dropdown as AntDropdown } from 'antd';
import type { DropdownProps } from 'antd';
import clsx from 'clsx';

/**
 * Thin wrapper over the Antd Dropdown (per the antd wrapper standardization plan):
 * single import source through @common/components. Dropdown is a portal-rendered
 * overlay — `overlayClassName` is the antd-side hook that lands on the floating
 * panel, so the `wk-dropdown` class is merged there (matches the Popover and
 * Tooltip wrappers). `className` on `<Dropdown>` is forwarded through
 * rc-trigger to the cloned trigger child rather than the overlay, which is
 * almost never what a caller wants.
 */
export const Dropdown = ({ overlayClassName, ...props }: DropdownProps) => (
  <AntDropdown
    {...props}
    overlayClassName={clsx('wk-dropdown', overlayClassName)}
  />
);

Dropdown.Button = AntDropdown.Button;
